(() => {
  const visible = element => element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden' && !element.closest('[inert],[hidden]');
  const focusable = element => [...element.querySelectorAll('a[href],button,input,select,textarea,[tabindex]:not([tabindex="-1"])')].filter(item => !item.disabled && visible(item));
  const dialogs = [];
  function registerDialog(element, isOpen, close, label) {
    if (!element) return;
    element.setAttribute('role', 'dialog');
    element.setAttribute('aria-label', label);
    element.setAttribute('aria-modal', 'true');
    element.tabIndex = -1;
    let previous = null, wasOpen = false;
    function sync() {
      const open = isOpen();
      element.inert = !open;
      element.setAttribute('aria-hidden', String(!open));
      if (open && !wasOpen) {
        previous = document.activeElement;
        (focusable(element)[0] || element).focus({ preventScroll: true });
      } else if (!open && wasOpen && previous && previous.isConnected && visible(previous)) {
        previous.focus({ preventScroll: true });
      }
      wasOpen = open;
    }
    new MutationObserver(sync).observe(element, { attributes: true, attributeFilter: ['class', 'style'] });
    sync();
    dialogs.push({ element, isOpen, close });
  }
  const menu = document.querySelector('.nav-mobile-menu');
  registerDialog(menu, () => menu.classList.contains('open'), () => menu.querySelector('.nav-mobile-close')?.click(), 'Navigation menu');
  const drawer = document.getElementById('bm-drawer');
  if (drawer) {
    const close = drawer.querySelector('button');
    if (close) { close.type = 'button'; close.setAttribute('aria-label', 'Close cart'); }
  }
  registerDialog(drawer, () => drawer.style.transform === 'translateX(0px)' || drawer.style.transform === 'translateX(0)', () => window.bmCloseCart?.(), 'Your cart');
  document.addEventListener('keydown', event => {
    const active = [...dialogs].reverse().find(dialog => dialog.isOpen());
    if (active && event.key === 'Escape') { event.preventDefault(); active.close(); return; }
    if (active && event.key === 'Tab') {
      const items = focusable(active.element), first = items[0], last = items.at(-1);
      if (!first) { event.preventDefault(); active.element.focus(); return; }
      if (event.shiftKey && (document.activeElement === first || !active.element.contains(document.activeElement))) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && (document.activeElement === last || !active.element.contains(document.activeElement))) { event.preventDefault(); first.focus(); }
    }
    if (event.key === 'Escape') document.querySelectorAll('.nav-dropdown.open').forEach(dropdown => {
      dropdown.classList.remove('open');
      const toggle = dropdown.querySelector('.nav-dropdown-toggle');
      toggle?.setAttribute('aria-expanded', 'false');
      toggle?.focus();
    });
  });
  document.querySelectorAll('.purchase-option').forEach(option => {
    option.setAttribute('role', 'radio');
    option.tabIndex = 0;
    const sync = () => option.setAttribute('aria-checked', String(option.classList.contains('selected')));
    sync();
    new MutationObserver(sync).observe(option, { attributes: true, attributeFilter: ['class'] });
    option.addEventListener('keydown', event => {
      if (event.key === ' ' || event.key === 'Enter') { event.preventDefault(); option.click(); }
      if (['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(event.key)) {
        event.preventDefault();
        const options = [...document.querySelectorAll('.purchase-option')].filter(visible);
        const step = ['ArrowLeft', 'ArrowUp'].includes(event.key) ? -1 : 1;
        const next = options[(options.indexOf(option) + step + options.length) % options.length];
        next?.focus(); next?.click();
      }
    });
  });
  document.querySelectorAll('input[type="email"]').forEach(input => {
    if (!input.labels?.length && !input.hasAttribute('aria-label')) input.setAttribute('aria-label', 'Email address');
    input.autocomplete = 'email';
  });
  document.querySelectorAll('.qty').forEach(group => {
    const input = group.querySelector('input');
    if (input) {
      input.setAttribute('aria-label', 'Quantity'); input.inputMode = 'numeric'; input.pattern = '[0-9]*';
      function syncQuantity(final) {
        if (!final && input.value === '') return;
        const value = Number(input.value);
        input.value = String(Number.isSafeInteger(value) && value > 0 ? value : 1);
        window.bmUpdateAtcPrice?.();
        window.bmSyncWallet?.();
      }
      input.addEventListener('input', () => syncQuantity(false));
      input.addEventListener('change', () => syncQuantity(true));
      input.addEventListener('blur', () => syncQuantity(true));
    }
    [...group.querySelectorAll('button')].forEach((button, index) => { button.type = 'button'; button.setAttribute('aria-label', index === 0 ? 'Decrease quantity' : 'Increase quantity'); });
  });
})();
